import { FC } from 'react';
import { SText } from '@setvi/shared/components';
import { ILabelValueField, onLabelValueChangeHandler } from '../../../../types';
import { BaseLabelFieldCard, BaseLabelValueFieldRow } from '../../../../styled';
import {
  EnhancedLabelValueFieldCard,
  EnhancedLabelValueFieldInput
} from './styled';
import { useGradientBorderStyles } from '../../../../hooks/useGradientBorderStyles';

interface EnhancedLabelValueProps {
  field: ILabelValueField;
  onLabelValueChange: onLabelValueChangeHandler;
}

export const EnhancedLabelValue: FC<EnhancedLabelValueProps> = ({
  field,
  onLabelValueChange
}) => {
  const { inputBorderGradientClass } = useGradientBorderStyles({
    gradient: 'enhanced',
    backgroundColor: '#fff'
  });

  // ! render
  return (
    <EnhancedLabelValueFieldCard>
      {field.data.map(({ label, value }, index) => (
        <BaseLabelValueFieldRow key={`${label}-${index + 1}`}>
          <BaseLabelFieldCard>
            <SText title={label} weight="normal" size="sm" />
          </BaseLabelFieldCard>

          <EnhancedLabelValueFieldInput
            multiline
            maxRows={10}
            type="text"
            placeholder=""
            className={inputBorderGradientClass}
            value={value}
            onChange={event =>
              onLabelValueChange(field.id, index, event.target.value)
            }
          />
        </BaseLabelValueFieldRow>
      ))}
    </EnhancedLabelValueFieldCard>
  );
};
